"use strict";
angular.module("settingTransmissionModule", ['tManageMentServiceModule'])
    .controller("settingTransmissionCtrl", ["$scope", "$modalInstance", "tManageMentService", "item", "trsHttpService", "modalDialog", "$validation", function($scope, $modalInstance, tManageMentService, item, trsHttpService, modalDialog, $validation) {
        initStatus();
        initData();
        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.data = {
                settingTransData:[],
                setting:[],
            };
            /**
             * 获取设置传播力指数参数
             * **/
            $scope.params = {
                serviceid: "mlf_tenant",
                methodname: "queryTenantPropagationForce",
                TENANTID: item.TENANTID
            };
            /**
             * 保存设置传播力指数
             * **/
            $scope.saveParams = {
                serviceid: "mlf_tenant",
                methodname: "updateTenantPropagationForce",
                TENANTID: item.TENANTID
            };
        }
        /** [initData description: 初始化数据] */
        function initData() {
            requestBrData();
        }
        function   requestBrData(){
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.settingTransData=data.map(function(value,key){
                    var obj={
                        key: value.KEY,
                        value: value.VALUE,
                        quanZhong:value.QUANZHONG,
                        choice:value.CHOOSEN=='false'?false:true,
                    }
                    return obj;
                });
            });
        }
        /**
         * 传播力指数设置
         * **/
        $scope.selectItem=function(item){
            item.choice=!item.choice;
        };
        /** [confirm description:确定保存信息] */
        $scope.confirm = function() {
            angular.forEach($scope.data.settingTransData,function(value,key){
                if(value.choice){
                    $scope.data.setting.push({quanZhong:value.quanZhong,key:value.key});
                }
            });
            if($scope.data.setting!=''){
                $scope.saveParams.CONFIGS=JSON.stringify($scope.data.setting);
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.saveParams, 'post').then(function(data) {
                if (data) {
                    modalDialog.alertType('', '设置成功', "success", false);
                } else {
                    modalDialog.alertType('', '设置失败', "error", false);
                }
                $modalInstance.close(data);
            });
        };
        //点击关闭
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);